import { createContext, useEffect, useState } from 'react'
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  GoogleAuthProvider,
  signInWithPopup,
  sendEmailVerification,
  applyActionCode,
  onAuthStateChanged
} from 'firebase/auth'
import { auth } from '../firebase/firebaseConfig'

const AuthContext = createContext()

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState({})
  const [loading, setLoading] = useState(false)
  const [product, setProduct] = useState([])
  const [emailVerify, setEmailVerify] = useState(false)
  const [userRegister, setUserRegister] = useState({})
  const [oobCode, setOobCode] = useState('')

  const signup = (email, password) => {
    return createUserWithEmailAndPassword(auth, email, password)
  }

  const login = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password)
  }

  const loginWithGoogle = () => {
    const googleProvider = new GoogleAuthProvider()

    return signInWithPopup(auth, googleProvider)
  }

  const forgotPassword = (email) => {
    return sendPasswordResetEmail(auth, email)
  }

  const logout = () => signOut(auth)

  const applyActionCodeEmail = (code) => {
    return applyActionCode(auth, code)
  }

  useEffect(() => {
    const autenticandoUsuario = async () => {
      const userLogin = await sessionStorage.getItem('user')

      if (userLogin || userRegister) {
        setLoading(true)
        setUserRegister(JSON.parse(userLogin))

        return
      }

      setLoading(false)
    }

    autenticandoUsuario()
  }, [])

  useEffect(() => {
    const unsubuscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser)
      }
    })

    return () => unsubuscribe()
  }, [])

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        product,
        emailVerify,
        userRegister,
        oobCode,
        applyActionCodeEmail,
        setEmailVerify,
        signup,
        login,
        logout,
        loginWithGoogle,
        setUser,
        setUserRegister,
        setProduct,
        setLoading,
        sendEmailVerification,
        forgotPassword,
        setOobCode
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export { AuthProvider }
export default AuthContext
